import { render } from "./AddTalentToTeam.vue?vue&type=template&id=7c6b9b1c"
import script from "./AddTalentToTeam.vue?vue&type=script&lang=js"
export * from "./AddTalentToTeam.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__